import React, { useState, useEffect, useCallback, useRef } from 'react'
import Header from '../Header/Header';
import { FaEdit } from "react-icons/fa";
import { baseUrl } from '../../Urls';
import { useNavigate, useLocation } from 'react-router-dom';
import '../Forms/salesform.css';
import { LuShrink } from "react-icons/lu";
import { IoExpand } from "react-icons/io5";
import { toast } from 'react-toastify';
import ExpandableText from '../../components/ExpandableText/ExpandableText';

function SalesForm() {
    const today = new Date().toISOString().split('T')[0];
    const [formData, setFormData] = useState({
        soDate: '',
        soDateTwo: '',
        soDateThree: '',
        estDate: '',
        date: today,
        sNo: '',
        companyName: '',
        productName: '',
        addressLine1: '',
        contactPerson: '',
        phone: '',
        tel: '',
        email: '',
        quotationNo: '',
        amount: '',
        estimator: '',
        scope: '',
        source: '',
        note: '',
        reason: '',
        status: '',
        poStatus: '',
        attachments: [],
        estAttachments: [],
        qutPdf: [],
        poAttachments: [],
        assignedBy: '',
        assignedTo: '',
        soNote: '',
        soNoteTwo: '',
        soNoteThree: '',
    });

    const [errors, setErrors] = useState({});
    const [salesList, setSalesList] = useState([]);
    const [isEditing, setIsEditing] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [fromLead, setFromLead] = useState(false);
    const [fromCustomer, setFromCustomer] = useState(false);
    const [fromEstimation, setFromEstimation] = useState(false);
    const [fromSalesOrder, setFromSalesOrder] = useState(false);
    const [loading, setLoading] = useState(false);
    const [saving, setSaving] = useState(false);
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const attachmentsRef = useRef(null);
    const estAttachmentsRef = useRef(null);
    const qutPdfRef = useRef(null);
    const poAttachmentsRef = useRef(null);


    const [showFollowUp, setShowFollowUp] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    const fetchSales = useCallback(async () => {
        try {
            setLoading(true);
            const response = await fetch(`${baseUrl}/api/sales`, {
                method: 'GET',
                credentials: 'include',
            });
            const data = await response.json();
            setSalesList(data);
            if (!location.state?.sale) {
                const latestSNo = data.length > 0 ? Math.max(...data.map(s => s.sNo || 0)) + 1 : 5167;
                setFormData(prev => ({ ...prev, sNo: latestSNo }));
            }
        } catch (error) {
            console.error('Error fetching sales:', error);
        } finally {
            setLoading(false);
        }
    }, [location.state?.sale]);

    useEffect(() => {
        fetchSales();
        const origin = location.state?.from;

        if (location.state?.sale) {
            const saleToEdit = location.state.sale;

            const isFromLead = origin === 'sales-enq-list' || origin === 'sales';
            const isFromCustomer = origin === 'customer';
            const isFromEstimation = origin === 'estimation';
            const isFromSalesOrder = origin === 'sales-order';

            setFromLead(isFromLead);
            setFromCustomer(isFromCustomer);
            setFromEstimation(isFromEstimation);
            setFromSalesOrder(isFromSalesOrder);

            setShowFollowUp(!isFromLead);

            setFormData({
                ...saleToEdit,
                soDate: isFromSalesOrder
                    ? saleToEdit.soDate || new Date().toISOString().split('T')[0]
                    : saleToEdit.soDate ?? '',
                soDateTwo: isFromSalesOrder
                    ? saleToEdit.soDateTwo || new Date().toISOString().split('T')[0]
                    : saleToEdit.soDateTwo ?? '',
                soDateThree: isFromSalesOrder
                    ? saleToEdit.soDateThree || new Date().toISOString().split('T')[0]
                    : saleToEdit.soDateThree ?? '',
                estDate: isFromEstimation
                    ? saleToEdit.estDate || new Date().toISOString().split('T')[0]
                    : saleToEdit.estDate ?? '',
                date: saleToEdit.date ?? '',
                sNo: saleToEdit.sNo ?? '',
                companyName: saleToEdit.companyName ?? '',
                productName: saleToEdit.productName ?? '',
                addressLine1: saleToEdit.addressLine1 ?? '',
                contactPerson: saleToEdit.contactPerson ?? '',
                phone: saleToEdit.phone ?? '',
                tel: saleToEdit.tel ?? '',
                email: saleToEdit.email ?? '',
                quotationNo: saleToEdit.quotationNo ?? '',
                amount: saleToEdit.amount ?? '',
                estimator: saleToEdit.estimator ?? '',
                scope: saleToEdit.scope ?? '',
                source: saleToEdit.source ?? '',
                note: saleToEdit.note ?? '',
                reason: saleToEdit.reason ?? '',
                status: saleToEdit.status ?? '',
                poStatus: saleToEdit.poStatus || 'inProgress',
                attachments: saleToEdit.attachments || [],
                estAttachments: saleToEdit.estAttachments || [],
                qutPdf: saleToEdit.qutPdf || [],
                poAttachments: saleToEdit.poAttachments || [],
                _id: saleToEdit._id ?? '',
                assignedBy: saleToEdit.assignedBy ?? '',
                assignedTo: saleToEdit.assignedTo ?? '',
                soNote: saleToEdit.soNote ?? '',
                soNoteTwo: saleToEdit.soNoteTwo ?? '',
                soNoteThree: saleToEdit.soNoteThree ?? '',
            });

            setIsEditing(true);
        } else {
            setFromLead(false);
            setFromCustomer(false);
            setFromEstimation(false);
            setFromSalesOrder(false);
            setShowFollowUp(false);
        }

        window.history.replaceState({}, document.title);
    }, [location.state, fetchSales]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "status") {
            setFormData(prev => ({
                ...prev,
                status: value,
                poAttachments: value === 'won' ? prev.poAttachments : [],
                reason: value === 'won' ? '' : prev.reason
            }));
            return;
        }

        if (name === "amount") {
            let raw = value.replace(/[^0-9.]/g, "");
            setFormData((prev) => ({
                ...prev,
                [name]: raw,
            }));
            validateField(name, raw);
        } else if (name !== "scope") {
            setFormData(prev => ({ ...prev, [name]: value }));
            validateField(name, value); // all other validations except scope
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }));
            // validateField(name, value);
        }
    };
    const validateField = (name, value) => {
        // let message = '';

        // switch (name) {
        //     case 'companyName':
        //     case 'productName':
        //     case 'contactPerson':
        //         if (!/^[A-Za-z0-9\s.,()&-]*$/.test(value)) {
        //             message = 'Only letters allowed.';
        //         }
        //         break;

        //     case 'phone':
        //     case 'tel': {
        //         message = '';
        //         break;
        //     }

        //     case 'email':
        //         if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
        //             message = 'Please enter a valid email address';
        //         }
        //         break;

        //     case 'amount':
        //         if (value === '') {
        //             message = '';
        //         } else if (!/^\d{1,3}(,\d{3})*(\.\d{1,2})?$/.test(value) && !/^\d+(\.\d{1,2})?$/.test(value)) {
        //             message = 'Only positive numbers allowed (e.g. 10,000 or 10000.50)';
        //         }
        //         break;

        //     case 'estimator':
        //         if (value === '') {
        //             message = 'Please select an estimator.';
        //         }
        //         break;

        //     case 'date':
        //         const datePattern = /^\d{4}-\d{2}-\d{2}$/;
        //         if (!datePattern.test(value)) {
        //             message = 'Please enter a valid date in YYYY-MM-DD format.';
        //         } else {
        //             const year = parseInt(value.split('-')[0], 10);
        //             if (year < 1900 || year > 2099) {
        //                 message = 'Year must be between 1900 and 2099.';
        //             }
        //         }
        //         break;

        //     case 'quotationNo':
        //         if (
        //             value.trim() !== '' &&
        //             !/^\s*\d+\s*(-\s*)?[Rr]ev\s+\d+\s*$/.test(value.trim())
        //         ) {
        //             message = 'Format must be like "2737 - Rev 0" or "2737 Rev 0"';
        //         }
        //         break;

        //     default:
        //         message = '';
        // }

        setErrors((prev) => ({
            ...prev,
            [name]: '',
        }));
    };

    const validateForm = () => {
        const newErrors = {};

        if (!fromCustomer && !fromEstimation && !fromSalesOrder) {
            if (!formData.scope?.trim()) {
                newErrors.scope = "Scope is required.";
                toast.error("Please enter scope");
            }
        }

        if (!formData.date.trim()) newErrors.date = 'Date is required.';
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        try {
            setSaving(true);
            const formPayload = {
                ...formData,
                amount: Number(String(formData.amount || '0').replace(/,/g, '')),
            };
            if (!isEditing) delete formPayload._id;

            let response;

            if (isEditing && formData._id) {
                response = await fetch(`${baseUrl}/api/sales/${formData._id}`, {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formPayload)
                });
            } else {

                response = await fetch(`${baseUrl}/api/sales`, {
                    method: 'POST',
                    credentials: 'include',
                    headers: {

                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formPayload)
                });
            }

            const rawText = await response.text();
            if (!response.ok) {
                toast.dismiss();
                toast.error(isEditing ? "Failed to update ❌" : "Failed to save ❌");
                throw new Error(`Server error: ${response.status} - ${rawText}`);
            }

            let savedSale;
            savedSale = JSON.parse(rawText);

            if (savedSale?.offline) {
                alert("Sale saved offline and will sync once you're online.");
                return;
            }
            toast.dismiss();
            toast.success(isEditing ? "Updated successfully ✅" : "Saved successfully ✅",
                { toastId: "update-success" }
            );
            // Trigger WON notification
            if (formData.status === "won") {
                const nameToShow = formData.companyName?.trim()
                    ? formData.companyName
                    : formData.contactPerson;
                console.log("STATUS VALUE:", formData.status);
                sessionStorage.setItem(
                    "wonNotification",
                    JSON.stringify({
                        name: nameToShow,
                        assignedTo: formData.assignedTo
                    })
                );
            }
            if (isEditing && formData._id) {
                setSalesList(prev =>
                    prev.map(sale => (sale._id === savedSale._id ? savedSale : sale))
                );
                if (fromLead) {
                    navigate('/sales-enq-list');
                    return;
                }
                if (fromCustomer) {
                    navigate('/customer');
                    return;
                }
                if (fromEstimation) {
                    navigate('/estimation');
                    return;
                }
                if (fromSalesOrder) {
                    navigate('/sales-order');
                    return;
                }
            } else {
                setSalesList(prev => [...prev, savedSale]);
            }
            setIsEditing(false);

            const allSales = [...salesList, savedSale];
            const nextSNo = allSales.length > 0 ? Math.max(...allSales.map(s => s.sNo || 0)) + 1 : 5167;

            setFormData(prev => ({
                ...prev,
                sNo: nextSNo,
                soDate: fromSalesOrder ? new Date().toISOString().split('T')[0] : '',
                soDateTwo: fromSalesOrder ? new Date().toISOString().split('T')[0] : '',
                soDateThree: fromSalesOrder ? new Date().toISOString().split('T')[0] : '',
                estDate: fromEstimation ? new Date().toISOString().split('T')[0] : '',
                date: today,
                companyName: '',
                productName: '',
                addressLine1: '',
                contactPerson: '',
                phone: '',
                tel: '',
                email: '',
                quotationNo: '',
                amount: '',
                estimator: '',
                scope: '',
                source: '',
                note: '',
                reason: '',
                status: '',
                attachments: [],
                assignedBy: '',
                assignedTo: '',
                soNote: '',
                soNoteTwo: '',
                soNoteThree: '',
            }));

            if (attachmentsRef.current) attachmentsRef.current.value = '';
            if (estAttachmentsRef.current) estAttachmentsRef.current.value = '';
            if (qutPdfRef.current) qutPdfRef.current.value = '';
            if (poAttachmentsRef.current) poAttachmentsRef.current.value = '';

            setErrors({});
            setIsEditing(false);

        } catch (error) {
            console.error('Error saving sale:', error);
        } finally {
            setSaving(false);
        }
    };

    const handleEdit = (sale, origin) => {
        const isFromLead = origin === 'sales-enq-list' || origin === 'sales';
        const isFromCustomer = origin === 'customer';
        const isFromEstimation = origin === 'estimation';
        const isFromSalesOrder = origin === 'sales-order';

        const updatedForm = {
            ...sale,
            soDate: isFromSalesOrder
                ? sale.soDate || new Date().toISOString().split('T')[0]
                : sale.soDate ?? '',
            soDateTwo: isFromSalesOrder
                ? sale.soDateTwo || new Date().toISOString().split('T')[0]
                : sale.soDateTwo ?? '',
            soDateThree: isFromSalesOrder
                ? sale.soDateThree || new Date().toISOString().split('T')[0]
                : sale.soDateThree ?? '',
            estDate: isFromEstimation
                ? sale.estDate || new Date().toISOString().split('T')[0]
                : sale.estDate ?? '',
            attachments: [],
            estAttachments: sale.estAttachments || [],
            estPdf: [],
        };

        setFormData(updatedForm);
        setIsEditing(true);
        setFromLead(isFromLead);
        setFromCustomer(isFromCustomer);
        setFromEstimation(isFromEstimation);
        setFromSalesOrder(isFromSalesOrder);

        setShowFollowUp(!isFromLead);

        navigate('/sales', { state: { sale, from: origin } });
    };

    const tableContainerRef = useRef(null);

    useEffect(() => {
        if (salesList.length && tableContainerRef.current) {
            tableContainerRef.current.scrollTop = tableContainerRef.current.scrollHeight;
        }
    }, [salesList]);

    const columns = [
        { key: 'edit', label: 'Edit', isAction: true },
        { key: 'sNo', label: 'SNo' },
        { key: 'date', label: 'Enq Date' },
        { key: 'contactPerson', label: 'Contact Person' },
        { key: 'companyName', label: 'Company Name' },
        { key: 'phone', label: 'Phone' },
        { key: 'productName', label: 'Product Name' },
        { key: 'tel', label: 'Telephone' },
        { key: 'email', label: 'Email' },
        { key: 'scope', label: 'Scope/Note', render: (sale) => <ExpandableText text={sale.scope} maxLines={2} />, },
        { key: 'source', label: 'Source' },
        { key: 'attachments', label: 'Lead Attachments', isAttachment: true },
        { key: 'addressLine1', label: 'Address' },
    ];

    return (
        <>
            <Header salesList={salesList} />
            <div className='container sales-form-container mb-3' style={{ marginTop: '100px' }}>
                <span
                    className="toggle-icon"
                    onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                    style={{ width: "40px" }}
                >
                    {isSidebarOpen ? <IoExpand /> : <LuShrink />}
                </span>
                <div className="row justify-content-center">
                    {isSidebarOpen && (
                        <div className="col-md-6 col-lg-4">
                            <div className="card shadow p-4 sales-form-container">
                                <h4>{isEditing ? 'Edit Enquiry' : 'New Enquiry'}</h4>
                                <hr />
                                <form onSubmit={handleSubmit} encType="multipart/form-data">
                                    {/* Lead Fields */}
                                    <div className="form-group mb-3">
                                        <label htmlFor="date">Enq Date</label>
                                        <input
                                            type="date"
                                            className="form-control"
                                            id="date"
                                            name="date"
                                            value={formData.date ?? ''}
                                            onChange={handleChange}
                                            min="1900-01-01"
                                            max="2026-12-31"
                                            disabled={fromCustomer || fromEstimation || fromSalesOrder}
                                        />
                                        {errors.date && <small className="text-danger">{errors.date}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="sNo">S.No</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="sNo"
                                            name="sNo"
                                            value={formData.sNo ?? ''}
                                            onChange={handleChange}
                                            disabled={true}
                                        />
                                        {errors.sNo && <small className="text-danger">{errors.sNo}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="companyName">Company Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="companyName"
                                            name="companyName"
                                            value={formData.companyName ?? ''}
                                            onChange={handleChange}
                                        />
                                        {errors.companyName && <small className="text-danger">{errors.companyName}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="productName">Product Name</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="productName"
                                            name="productName"
                                            value={formData.productName ?? ''}
                                            onChange={handleChange}
                                        />
                                        {errors.productName && <small className="text-danger">{errors.productName}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="addressLine1">Address</label>
                                        <textarea
                                            className="form-control"
                                            id="addressLine1"
                                            name="addressLine1"
                                            rows="3"
                                            value={formData.addressLine1 ?? ''}
                                            onChange={handleChange}
                                        ></textarea>
                                        {errors.addressLine1 && <small className="text-danger">{errors.addressLine1}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="contactPerson">Contact Person</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="contactPerson"
                                            name="contactPerson"
                                            value={formData.contactPerson ?? ''}
                                            onChange={handleChange}
                                        />
                                        {errors.contactPerson && <small className="text-danger">{errors.contactPerson}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="phone">Mobile No</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="phone"
                                            name="phone"
                                            value={formData.phone ?? ''}
                                            onChange={handleChange}
                                        />
                                        {errors.phone && <small className="text-danger">{errors.phone}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="tel">Tel No</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="tel"
                                            name="tel"
                                            value={formData.tel ?? ''}
                                            onChange={handleChange}
                                        // pattern="^\+?\d{10,15}$"
                                        />
                                        {errors.tel && <small className="text-danger">{errors.tel}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="email">Email address</label>
                                        <input
                                            type="email"
                                            className="form-control"
                                            id="email"
                                            name="email"
                                            value={formData.email ?? ''}
                                            onChange={handleChange}
                                        />
                                        {errors.email && <small className="text-danger">{errors.email}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="scope">Scope/Note</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="scope"
                                            name="scope"
                                            value={formData.scope ?? ''}
                                            onChange={handleChange}
                                            disabled={fromCustomer || fromEstimation}
                                        />
                                        {errors.scope && <small className="text-danger">{errors.scope}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="source">Source</label>
                                        <select
                                            className="form-control"
                                            id="source"
                                            name="source"
                                            value={formData.source ?? ''}
                                            onChange={handleChange}
                                        >
                                            <option value="">-- Select --</option>
                                            <option value="IndiaMart">IndiaMart</option>
                                            <option value="Website">Website</option>
                                            <option value="Mail">Mail</option>
                                            <option value="Prev-Client">Prev.Client</option>
                                            <option value="Distributor">Distributor</option>
                                            <option value="Thomas Philip">Thomas Philip</option>
                                            <option value="Vinayan Nambiar">Vinayan Nambiar</option>
                                            <option value="Vishnu">Vishnu</option>
                                            <option value="Amal">Amal</option>
                                            <option value="Shobana Devi">Shobana Devi</option>
                                            <option value="Joe">Joe</option>
                                            <option value="Karthikeyan">Karthikeyan</option>
                                            <option value="Other">Other</option>
                                        </select>
                                        {errors.source && <small className="text-danger">{errors.source}</small>}
                                    </div>
                                    <div className="form-group mb-3">
                                        <label htmlFor="attachments">Paste Lead Drive Link</label>
                                        <textarea
                                            className="form-control"
                                            id="attachments"
                                            name="attachments"
                                            ref={attachmentsRef}
                                            multiple
                                            placeholder="Paste one or more links"
                                            rows="3"
                                            value={formData.attachments.join('\n')}
                                            onChange={(e) => {
                                                const input = e.target.value;
                                                const links = input
                                                    .replace(/(https?:\/\/[^ ]+?\.pdf)(?=https?:\/\/)/g, '$1\n')
                                                    .split(/\s+/)
                                                    .map(link => link.trim())
                                                    .filter(Boolean);

                                                setFormData(prev => ({
                                                    ...prev,
                                                    attachments: links
                                                }));
                                            }}
                                            disabled={fromEstimation}
                                        />
                                        {errors.attachments && <small className="text-danger">{errors.attachments}</small>}
                                    </div>


                                    {showFollowUp && (
                                        <>
                                            {/* Assign Fields */}
                                            <div className="form-group mb-3">
                                                <label htmlFor="assignedBy">Assigned-by</label>
                                                <select
                                                    className="form-control"
                                                    id="assignedBy"
                                                    name="assignedBy"
                                                    value={formData.assignedBy ?? ''}
                                                    onChange={handleChange}
                                                    disabled={location.state?.from !== 'customer'}
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="Vishnu">Vishnu</option>
                                                    <option value="Amal">Amal</option>
                                                    <option value="Suresh">Suresh</option>
                                                    <option value="Thomas Philip">Thomas Philip</option>
                                                    <option value="Vinayan Nambiar">Vinayan Nambiar</option>
                                                    <option value="Sukesh Krishnan">Sukesh Krishnan</option>
                                                </select>
                                                {errors.assignedBy && <small className="text-danger">{errors.assignedBy}</small>}
                                            </div>
                                            <div className="form-group mb-3">
                                                <label htmlFor="assignedTo">Assigned-To</label>
                                                <select
                                                    className="form-control"
                                                    id="assignedTo"
                                                    name="assignedTo"
                                                    value={formData.assignedTo ?? ''}
                                                    onChange={handleChange}
                                                    disabled={location.state?.from !== 'customer'}
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="Vishnu">Vishnu</option>
                                                    <option value="Amal">Amal</option>
                                                    <option value="Shobana Devi">Shobana Devi</option>
                                                    <option value="Joe">Joe</option>
                                                    <option value="Karthikeyan">Karthikeyan</option>
                                                    <option value="Kavitha">Kavitha</option>
                                                    <option value="Emil">Emil</option>
                                                    <option value="Hridya">Hridya</option>
                                                    <option value="Suresh">Suresh</option>
                                                    <option value="Thomas Philip">Thomas Philip</option>
                                                    <option value="Vinayan Nambiar">Vinayan Nambiar</option>
                                                    <option value="Sukesh Krishnan">Sukesh Krishnan</option>
                                                </select>
                                                {errors.assignedTo && <small className="text-danger">{errors.assignedTo}</small>}
                                            </div>
                                            <div className="form-group mb-3">
                                                <label htmlFor="note">Note</label>
                                                <textarea
                                                    className="form-control"
                                                    id="note"
                                                    name="note"
                                                    rows="2"
                                                    value={formData.note ?? ''}
                                                    onChange={handleChange}
                                                    disabled={fromEstimation || fromSalesOrder}
                                                ></textarea>
                                                {errors.note && <small className="text-danger">{errors.note}</small>}
                                            </div>
                                            {location.state?.from !== 'customer' && (
                                                <>
                                                    {/* Estimation Fields */}
                                                    {(fromEstimation || fromSalesOrder) && (
                                                        <div className="form-group mb-3">
                                                            <label htmlFor="estDate">Quotation Date</label>
                                                            <input
                                                                type="date"
                                                                className="form-control"
                                                                name="estDate"
                                                                id="estDate"
                                                                value={formData.estDate ?? ''}
                                                                onChange={handleChange}
                                                                disabled={!fromEstimation}
                                                            />
                                                        </div>
                                                    )}
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="quotationNo">Quotation No</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            id="quotationNo"
                                                            name="quotationNo"
                                                            value={formData.quotationNo ?? ''}
                                                            onChange={handleChange}
                                                            disabled={!fromEstimation}
                                                        />
                                                        {errors.quotationNo && <small className="text-danger">{errors.quotationNo}</small>}
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="estimator">Estimator</label>
                                                        <select
                                                            className="form-control"
                                                            id="estimator"
                                                            name="estimator"
                                                            value={formData.estimator ?? ''}
                                                            onChange={handleChange}
                                                            disabled={!fromEstimation}
                                                        >
                                                            <option value="">-- Select --</option>
                                                            <option value="Hridya">Hridya</option>
                                                            <option value="Emil">Emil</option>
                                                        </select>
                                                        {errors.estimator && <small className="text-danger">{errors.estimator}</small>}
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="estAttachments">Paste Estimation Drive Link</label>
                                                        <textarea
                                                            className="form-control"
                                                            id="estAttachments"
                                                            name="estAttachments"
                                                            ref={estAttachmentsRef}
                                                            multiple
                                                            placeholder="Paste one or more Google Drive links, separated by new lines"
                                                            rows="3"
                                                            value={formData.estAttachments.join('\n')}
                                                            onChange={(e) => {
                                                                const input = e.target.value;
                                                                const links = input
                                                                    .replace(/(https?:\/\/[^ ]+?\.pdf)(?=https?:\/\/)/g, '$1\n')
                                                                    .split(/\s+/)
                                                                    .map(link => link.trim())
                                                                    .filter(Boolean);

                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    estAttachments: links
                                                                }));
                                                            }}
                                                            disabled={!fromEstimation}
                                                        />
                                                        {errors.estAttachments && <small className="text-danger">{errors.estAttachments}</small>}
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="qutPdf">Paste Quotation PDF Drive Link</label>
                                                        <textarea
                                                            className="form-control"
                                                            id="qutPdf"
                                                            name="qutPdf"
                                                            ref={qutPdfRef}
                                                            multiple
                                                            placeholder="Paste one or more Google Drive links, separated by new lines"
                                                            rows="3"
                                                            value={formData.qutPdf.join('\n')}
                                                            onChange={(e) => {
                                                                const input = e.target.value;
                                                                const links = input
                                                                    .replace(/(https?:\/\/[^ ]+?\.pdf)(?=https?:\/\/)/g, '$1\n')
                                                                    .split(/\s+/)
                                                                    .map(link => link.trim())
                                                                    .filter(Boolean);

                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    qutPdf: links
                                                                }));
                                                            }}
                                                            disabled={!fromEstimation}
                                                        />
                                                        {errors.qutPdf && <small className="text-danger">{errors.qutPdf}</small>}
                                                    </div>
                                                    <div className="form-group mb-3">
                                                        <label htmlFor="poStatus">Proposal Status</label>
                                                        <input
                                                            className="form-control"
                                                            id="poStatus"
                                                            name="poStatus"
                                                            value={formData.poStatus ?? ''}
                                                            onChange={handleChange}
                                                            disabled={!fromEstimation}
                                                        />
                                                        {errors.poStatus && <small className="text-danger">{errors.poStatus}</small>}
                                                    </div>
                                                    {/* Sales Order Fields */}
                                                    {location.state?.from !== 'estimation' && (
                                                        <>
                                                            <div className="row g-3">
                                                                <div className="col-md-4 form-group mb-3">
                                                                    <label htmlFor="soDate">Follow-Up-1</label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        name="soDate"
                                                                        id="soDate"
                                                                        value={formData.soDate ?? ''}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>

                                                                <div className="col-md-8">
                                                                    <label htmlFor="soNote">Note-1</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="soNote"
                                                                        id="soNote"
                                                                        value={formData.soNote ?? ''}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="row g-3">
                                                                <div className="col-md-4 form-group mb-3">
                                                                    <label htmlFor="soDateTwo">Follow-Up-2</label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        name="soDateTwo"
                                                                        id="soDateTwo"
                                                                        value={formData.soDateTwo ?? ''}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>

                                                                <div className="col-md-8">
                                                                    <label htmlFor="soNoteTwo">Note-2</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="soNoteTwo"
                                                                        id="soNoteTwo"
                                                                        value={formData.soNoteTwo ?? ''}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <div className="row g-3">
                                                                <div className="col-md-4 form-group mb-3">
                                                                    <label htmlFor="soDateThree">Follow-Up-3</label>
                                                                    <input
                                                                        type="date"
                                                                        className="form-control"
                                                                        name="soDateThree"
                                                                        id="soDateThree"
                                                                        value={formData.soDateThree ?? ''}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>

                                                                <div className="col-md-8">
                                                                    <label htmlFor="soNoteThree">Note-3</label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        name="soNoteThree"
                                                                        id="soNoteThree"
                                                                        value={formData.soNoteThree ?? ''}
                                                                        onChange={handleChange}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="status">Status</label>
                                                                <select
                                                                    className="form-control"
                                                                    id="status"
                                                                    name="status"
                                                                    value={formData.status ?? ''}
                                                                    onChange={handleChange}
                                                                    disabled={!fromSalesOrder}
                                                                >
                                                                    <option value="">-- Select --</option>
                                                                    <option value="won">Won</option>
                                                                    <option value="lose">Lose</option>
                                                                    <option value="pipeline">Pipeline</option>
                                                                </select>
                                                                {errors.status && <small className="text-danger">{errors.status}</small>}
                                                            </div>
                                                            <div className="form-group mb-3">
                                                                <label htmlFor="amount">Amount</label >
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="amount"
                                                                    name="amount"
                                                                    value={formData.amount ?? ''}
                                                                    onChange={handleChange}
                                                                    min="1"
                                                                />
                                                                {errors.amount && <small className="text-danger">{errors.amount}</small>}
                                                            </div>
                                                            {formData.status === 'won' && (
                                                                <div className="form-group mb-3">
                                                                    <label htmlFor="poAttachments">PO Attcahments Link</label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        id="poAttachments"
                                                                        name="poAttachments"
                                                                        ref={poAttachmentsRef}
                                                                        multiple
                                                                        placeholder="Paste one or more Google Drive links, separated by new lines"
                                                                        rows="3"
                                                                        value={formData.poAttachments.join('\n')}
                                                                        onChange={(e) => {
                                                                            const input = e.target.value;
                                                                            const links = input
                                                                                .replace(/(https?:\/\/[^ ]+?\.pdf)(?=https?:\/\/)/g, '$1\n')
                                                                                .split(/\s+/)
                                                                                .map(link => link.trim())
                                                                                .filter(Boolean);

                                                                            setFormData(prev => ({
                                                                                ...prev,
                                                                                poAttachments: links
                                                                            }));
                                                                        }}
                                                                    />
                                                                    {errors.poAttachments && <small className="text-danger">{errors.poAttachments}</small>}
                                                                </div>
                                                            )}
                                                            {formData.status !== 'won' && (
                                                                <div className="form-group mb-3">
                                                                    <label htmlFor="reason">Reason</label>
                                                                    <textarea
                                                                        className="form-control"
                                                                        id="reason"
                                                                        name="reason"
                                                                        rows="2"
                                                                        value={formData.reason ?? ''}
                                                                        onChange={handleChange}
                                                                    ></textarea>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </>
                                    )}
                                    <button type="submit" className="btn btn-primary" disabled={saving}>
                                        {saving ? "Saving..." : isEditing ? "Update" : "Save"}
                                    </button>
                                </form>
                            </div>
                        </div>
                    )}
                    <div className={`table-container-lead ${isSidebarOpen ? 'col-md-6 col-lg-7' : 'col-12'} order-1 order-md-1 order-lg-2 p-0`} ref={tableContainerRef}>
                        {loading ? (
                            <div className="spinner-container">
                                <div className="spinner"></div>
                                <p>Loading Lead data...</p>
                            </div>
                        ) : (
                            <table className="table table-bordered lead-table table-hover" style={{ fontSize: "14px", whiteSpace: "nowrap" }}>
                                <thead>
                                    <tr>
                                        {columns.map((col) => (
                                            <th key={col.key}>{col.label}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {salesList.length === 0 ? (
                                        <tr>
                                            <td colSpan="25" className="text-left text-dark">
                                                No data found
                                            </td>
                                        </tr>
                                    ) : (
                                        salesList.map((sale) => (
                                            <tr
                                                key={sale._id}
                                                onClick={() => setSelectedRow(selectedRow === sale._id ? null : sale._id)}
                                                className={selectedRow === sale._id ? 'highlight-row' : ''}
                                                style={{ cursor: "pointer" }}
                                            >
                                                {columns.map((col) => {
                                                    if (col.isAction) {
                                                        return (
                                                            <td key={col.key}>
                                                                <button
                                                                    onClick={() => handleEdit(sale, 'sales')}
                                                                    disabled={fromSalesOrder}
                                                                    style={{
                                                                        background: 'none',
                                                                        border: 'none',
                                                                        cursor: fromSalesOrder ? 'not-allowed' : 'pointer',
                                                                        color: fromSalesOrder ? '#ccc' : 'gray',
                                                                    }}
                                                                >
                                                                    <FaEdit />
                                                                </button> </td>);
                                                    }
                                                    if (col.isAttachment) {
                                                        return (
                                                            <td key={col.key}>
                                                                {sale[col.key]?.map((link, index) => (
                                                                    <div key={index}>
                                                                        <a href={link} target="_blank" rel="noopener noreferrer">
                                                                            View File {index + 1}
                                                                        </a>
                                                                    </div>))}</td>);
                                                    }
                                                    if (col.isCurrency) {
                                                        return (
                                                            <td key={col.key}>
                                                                {sale[col.key]
                                                                    ? new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR" }).format(sale[col.key])
                                                                    : ''}
                                                            </td>);
                                                    }
                                                    if (col.render) {
                                                        return <td key={col.key}>{col.render(sale)}</td>;
                                                    }
                                                    return <td key={col.key}>{sale[col.key] || ''}</td>;
                                                })}
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
}

export default SalesForm